/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/welcome/welcome.component';
import * as i2 from '@angular/router';
const styles_WelcomeComponent:any[] = ['.welcome-panel[_ngcontent-%COMP%] { text-align:center;margin:100px; }'];
export const RenderType_WelcomeComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_WelcomeComponent,data:{}});
export function View_WelcomeComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),4,'div',[['class','col-lg-12 welcome-panel']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n        Welcome to Scania PackIT.\n    '])),(_l()(),i0.ɵted((null as any),
          ['\n']))],(null as any),(null as any));
}
export function View_WelcomeComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'welcome',([] as any[]),
      (null as any),[['window','beforeunload']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:beforeunload' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).canDeactivate()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_WelcomeComponent_0,RenderType_WelcomeComponent)),i0.ɵdid(114688,(null as any),
      0,i1.WelcomeComponent,[i2.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WelcomeComponentNgFactory:i0.ComponentFactory<i1.WelcomeComponent> = i0.ɵccf('welcome',
    i1.WelcomeComponent,View_WelcomeComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL3dlbGNvbWUvd2VsY29tZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL3dlbGNvbWUvd2VsY29tZS5jb21wb25lbnQudHMiLCJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy9hcHAvd2VsY29tZS93ZWxjb21lLmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy9hcHAvd2VsY29tZS93ZWxjb21lLmNvbXBvbmVudC50cy5XZWxjb21lQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXHJcbjxkaXYgY2xhc3M9XCJjb2wtbGctMTIgd2VsY29tZS1wYW5lbFwiPlxyXG4gICAgPGgxPlxyXG4gICAgICAgIFdlbGNvbWUgdG8gU2NhbmlhIFBhY2tJVC5cclxuICAgIDwvaDE+XHJcbjwvZGl2PiIsIjx3ZWxjb21lPjwvd2VsY29tZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsdUNBQ0E7TUFBQTtNQUFBLDRDQUFxQztNQUNqQztVQUFBLDBEQUFJO1VBQUEsZ0RBRUM7VUFBQTs7O29CQ0pUO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSwrREFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/$$_gendir/app/welcome/welcome.component.ngfactory.ts